import React, { useState, useEffect } from 'react';
import Markdown from 'global/components/Markdown';
import NavToTop from 'feature/nav/NavToTop';
import { get } from 'global/lib/lodash';
import Link from 'react-router-dom/Link';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { CenterContent, GridContainer } from 'global/components/perform-grid';
import useStyles from './Policy.styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import HomeIcon from '@material-ui/icons/Home';
import Image from 'global/components/image';
import isLoggedIn from 'global/utils/isLoggedIn';
import logo from 'assets/perform_with_ibacos.svg';

import policy from 'global/../../PRIVACY_POLICY.md';
import terms from 'global/../../USER_AGREEMENT.md';
// import faq from 'global/../../README_FAQ.md';

export default function Policy(props) {
  const [markdown, setMarkdown] = useState('');
  const [page, setPage] = useState(policy);
  const classes = useStyles();
  const loggedIn = useSelector((state) => isLoggedIn(state.auth));

  const { type } = get(props, 'match.params', {});

  useEffect(() => {
    setPage(type === 'terms' ? terms : policy);
  }, [type]);

  useEffect(() => {
    fetch(page)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, [page]);

  return (
    <div>
      <AppBar position="static">
        <Toolbar component={Link} to="/" variant="dense">
          {loggedIn ? (
            <div className={classes.icon}>
              <HomeIcon />
              Home
            </div>
          ) : (
            <div className={classes.icon}>
              <HomeIcon />
              Login
            </div>
          )}
        </Toolbar>
      </AppBar>
      <GridContainer>
        <CenterContent className={classes.content}>
          <div className={classes.logos}>
            <Image src={logo} className={classes.performlogo} alt="" />
          </div>
          <Typography component={Link} to={type === 'terms' ? '/policy' : '/policy/terms'}>
            {type === 'terms' ? 'Privacy Policy' : 'User Agreement'}
          </Typography>
          <NavToTop />
          <Markdown>{markdown}</Markdown>
          <Typography component={Link} to={type === 'terms' ? '/policy' : '/policy/terms'} onClick={window.scroll(0, 0)}>
            {type === 'terms' ? 'Privacy Policy' : 'User Agreement'}
          </Typography>
        </CenterContent>
      </GridContainer>
    </div>
  );
}
